// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ErrorProvider } from './contexts/ErrorContext';
import { UserProvider } from './contexts/UserContext';
import { CardProvider } from './contexts/CardContext';
import { ContactLinkBaseUrlProvider } from './contexts/ContactLinkBaseUrlContext';
import { ContactLinkProvider } from './contexts/ContactLinkContext';
import { UserPreferencesProvider } from './contexts/UserPreferencesContext';
import { FollowUpEmailProvider } from './contexts/FollowUpContext';
import { QRCodeProvider } from './contexts/QrCodeContext';
import { LeadCaptureProvider } from './contexts/LeadCaptureContext';
import { VirtualBackgroundProvider } from './contexts/VirtualBackgroundContext';
import { EmailSignatureProvider } from './contexts/EmailSignatureContext';
import { TeamProvider } from './team/contexts/teamContext';
import { TeamMemberProvider } from './team/contexts/teamMemberContext';
import { TeamSubteamProvider } from './team/contexts/teamSubteamContext';
import ErrorBoundary from './components/ErrorBoundary';
import GlobalErrorNotification from './components/common/GlobalErrorNotification';
import { initializeApp } from './config/appSetup';

// Initialize app configuration
initializeApp();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <ErrorProvider>
      <AuthProvider>
        <UserProvider>
          <CardProvider>
            <ContactLinkBaseUrlProvider>
              <ContactLinkProvider>
                <UserPreferencesProvider>
                  <FollowUpEmailProvider>
                    <QRCodeProvider>
                      <LeadCaptureProvider>
                        <VirtualBackgroundProvider>
                          <EmailSignatureProvider>
                            <TeamProvider>
                              <TeamMemberProvider>
                                <TeamSubteamProvider>
                                  <App />
                                  <GlobalErrorNotification />
                                </TeamSubteamProvider>
                              </TeamMemberProvider>
                            </TeamProvider>
                          </EmailSignatureProvider>
                        </VirtualBackgroundProvider>
                      </LeadCaptureProvider>
                    </QRCodeProvider>
                  </FollowUpEmailProvider>
                </UserPreferencesProvider>
              </ContactLinkProvider>
            </ContactLinkBaseUrlProvider>
          </CardProvider>
        </UserProvider>
      </AuthProvider>
    </ErrorProvider>
  </ErrorBoundary>
);